<template>
  <a
    id="top-banner"
    href="https://guidy.ai/"
    target="_blank"
    class="top-banner no-hover"
    data-banner-content="what-gets-you-hired"
  >
    <div class="banner-container container">
      <img :src="require('../assets/images/meet-guidy.webp')" alt="Meet Guidy">
      <div class="left">
        Your new AI study buddy. <br><strong class="purple">Real-time help</strong> inside <strong>ANY</strong> software or website.
      </div>
      <button class="start-button btn-primary-purple">
        Start Now
      </button>
    </div>
  </a>
</template>

<script>
export default {
  components: {},
};
</script>
<style lang="scss" scoped>
.top-banner {
  color: var(--main-dark-shade-0);
  background-color: var(--extreme-yellow);
  height: 80px;
  border-top: 3px solid var(--main-purple);
  border-bottom: 3px solid var(--main-purple);
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .banner-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .left {
    font-size: 20px;
  }

  strong {
    font-weight: 700;

    &.purple {
      color: var(--main-purple);
    }
  }

  .start-button {
   width: 220px;
   height: 58px;
   border: 2px solid var(--main-dark);
  }
}

@include bp($bp-laptop) {
  .top-banner {
    .left {
      font-size: 18px;
    }
  }
}

@include bp($bp-mobile) {
  .top-banner {
    height: 280px;
    padding: 20px 24px 16px;

    .banner-container {
      flex-direction: column;
      padding: 0;
    }

    .left {
      margin-top: 20px;
      font-size: 18px;
      text-align: center;
    }

    .start-button {
      margin-top: 16px;
    }
  }
}
</style>
